<template>
    <div>

      <div  style="position:fixed; height:60px;  width:100vw" class="hidden-sm-and-down primary">

     </div>
      <v-layout justify-center style="position:relative;" >
        <v-flex xs12 md10>

            <v-layout elevation-3 style="background-color:white" >
              <!-- TASK LIST -->
              <v-flex xs12 md4 style="height:100%" >
                <div class="tasksHeader hidden-sm-and-down">
                <h5 class=" text-xs-center mb-2 mt-2 pa-1">{{gLang[lang].tasks.tasks}}</h5>                  
                </div>
                <v-layout row class=" primary pl-2 pr-2 hidden-md-and-up " style="">
                          <v-flex  xs12 sm12 offset-sm2  class=" mr-3 ml-3 white hidden-md-and-up">
                              <h3 class="mb-1 text-xs-center" style="color:grey">  {{gLang[lang].tasks.tasks}}</h3>
                          </v-flex>
                      </v-layout>

                <div v-if="unreviewedArtefacts.length > 0" class="tasksHeader">
                <p  class="  mb-2 mt-2 pa-2"> <v-icon class="pr-2">view_carousel</v-icon> {{gLang[lang].tasks.newArtefacts}}</p>                  
                </div>

                <v-layout row>
    <v-flex xs12 sm12 >
      <v-card style="box-shadow:none;">
        <v-list three-line class="pt-0">
          <template >
            <div v-for="(artefact,i) in unreviewedArtefacts" :key="i" >
            <v-divider  ></v-divider> 
            <v-list-tile @click="previewOrRedirect(artefact._id)" avatar   >
              <v-list-tile-avatar>
                <img v-bind:src="artefact.mainImg[0].url+ '_profile'"/>
              </v-list-tile-avatar>
              <v-list-tile-content  class="collection-list-ie  pt-3"  v-for="(user,i) in users" :key="i" v-if="(user._id.indexOf(artefact.userId) > -1)">
                <v-list-tile-title v-html="artefact.title[lang]"></v-list-tile-title>
                <v-list-tile-sub-title v-html=" user.displayName + ' - ' +artefact.description[lang]"></v-list-tile-sub-title>
                
                             <!-- <v-divider style="height:1px !important;line-height:1px !important;"></v-divider>  -->
              </v-list-tile-content>
                
            </v-list-tile>
            </div>
          </template>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>

                <div  v-if="toBeDeleted.length > 0" class="tasksHeader">
                <p class="  mb-2 mt-2 pa-2"> <v-icon class="pr-2">delete_forever</v-icon>To be Deleted</p>                  
                </div>

                    <v-flex xs12 sm12 >
      <v-card style="box-shadow:none;">
        <v-list three-line class="pt-0">
          <template >
            <div v-for="(artefact,i) in toBeDeleted" :key="i" >
            <v-divider  ></v-divider> 
            <v-list-tile @click="previewOrRedirect(artefact._id)" avatar   >
              <v-list-tile-avatar>
                <img v-bind:src="artefact.mainImg[0].url+ '_profile'"/>
              </v-list-tile-avatar>
              <v-list-tile-content  class="collection-list-ie  pt-3"  v-for="(user,i) in users" :key="i" v-if="(user._id.indexOf(artefact.userId) > -1)">
                <v-list-tile-title v-html="artefact.title[lang]"></v-list-tile-title>
                <v-list-tile-sub-title v-html=" user.displayName + ' - ' +artefact.description[lang]"></v-list-tile-sub-title>
                
                             <!-- <v-divider style="height:1px !important;line-height:1px !important;"></v-divider>  -->
              </v-list-tile-content>
                
            </v-list-tile>
            </div>
          </template>
        </v-list>
      </v-card>
    </v-flex>



                    <div  v-if="requests.length > 0" class="tasksHeader">
                <p class="  mb-2 mt-2 pa-2"> <v-icon class="pr-2">face</v-icon>User Change Role Requests</p>                  
                </div>

                    <v-flex xs12 sm12 >
      <v-card style="box-shadow:none;">
        <v-list three-line class="pt-0">
          <template >
            <div v-for="(request,i) in requests" :key="i" >
            <v-divider  ></v-divider> 
            <v-list-tile  avatar   >
              <v-list-tile-avatar>
                <img v-if="getRightPicture(request.user)!=false" v-bind:src="getRightPicture(request.user)"/>
                <v-icon v-else large>account_circle</v-icon>
              </v-list-tile-avatar>
              <v-layout>
                <v-flex xs8>
                  <v-list-tile-content  class="collection-list-ie pt-2" >
                <v-list-tile-title v-html="request.user.displayName"></v-list-tile-title>
                 <v-list-tile-sub-title>Current: {{request.user.role}}</v-list-tile-sub-title>
                <v-list-tile-sub-title>Desired: {{request.role}}</v-list-tile-sub-title>
                             <!-- <v-divider style="height:1px !important;line-height:1px !important;"></v-divider>  -->
              </v-list-tile-content>
                </v-flex>
                <v-flex xs2>
                  <v-btn icon @click="acceptUser(request.user,request.role,request._id)"> <v-icon>check_circle</v-icon> </v-btn>
                </v-flex>
                <v-flex xs2>
                  <v-btn icon @click="denyUser(request._id)"> <v-icon>clear</v-icon> </v-btn>
                </v-flex>
              </v-layout>
              
                
            </v-list-tile>
            </div>
          </template>
        </v-list>
      </v-card>
    </v-flex>



              </v-flex>

              <!-- PREVIEW TASK -->
              <v-flex hidden-xs-only md8>
                <web-artefact-preview v-if="preview" :id="preview" @artefactAccepted="acceptArtefact($event)" @deletedArtefact="deletedArtefact()"> </web-artefact-preview>
                <v-container fluid v-if="!preview" class="beginningContainer pa-5">
                  <h5><i> {{gLang[lang].tasks.previewText}} </i></h5>
                </v-container>
              </v-flex>
            </v-layout>

        </v-flex>
      </v-layout>
    </div>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      requests:"",
      preview: ""
    };
  },
  computed: {
    token() {
      return this.$store.getters.getToken
    },
    lang() {
      return this.$store.getters.loadLang;
    },
    gLang() {
      return this.$store.getters.loadGlobLang;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    // artefacts() {
    //   return this.$store.getters.loadUnreviewdArtefacts;
    // },
    artefacts() {
      return this.$store.getters.loadArtefacts;
    },
    collectionName() {
      return this.$store.getters.getCollectionName(this.id);
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    users() {
      return this.$store.getters.loadUsers;
    },
    unreviewedArtefacts() {
      return this.$store.getters.loadUnreviewedArtefacts;
    },
    toBeDeleted() {
      return this.$store.getters.loadToBeDeletedArtefacts;
    },
    isMod() {
      return this.$store.getters.isMod;
    },
    isContrib() {
      return this.$store.getters.isContrib;
    }
  },
  mounted: function() {
    window.scrollTo(0, 0);
    this.$store.dispatch("loadArtefacts");
  },
  methods: {
    denyUser(requestId){
       axios.delete('/api/requests/'+requestId).then((res)=>{
              this.loadRequests()
            })    
    },
    acceptUser(user,role,requestId){
        this.$store.dispatch("changeUserStatus", {
        id: user._id,
        token: this.token,
        role:role
      }).then((response)=>{
        if(response.success)
          {
            axios.delete('/api/requests/'+requestId).then((res)=>{
              this.loadRequests()
            })    
          }
      });
    },
    getRightPicture(user){
      try
      {
      let right_user
      if(user.email && this.$store.getters.getUserByEmail(user.email))
      {
      right_user = this.$store.getters.getUserByEmail(user.email)
      }

      if(user.live != undefined)
      return false
      else
      if(!user.email)
      return user.picture
      else if(user.email != "" && right_user.picture != undefined && right_user.picture !="") 
      return right_user.picture.url+'_profile'
      else return false
      } 
      catch(e)
      {
        return false
      }

    },
    loadRequests(){
      if(this.isAdmin)
      axios.get('/api/requests').then((response)=>{
        this.requests = response.data;
      })
    },
    acceptArtefact(id) {
      this.unreviewedArtefacts.filter(artefact => {
        artefact._id != id;
      });
      this.preview = false;
    },
    deletedArtefact(){
      this.$store.dispatch("loadArtefacts");
      this.preview = false;
    },
    previewOrRedirect(id) {
      if (screen.width > 960) {
        this.preview = id;
      } else {
        this.$router.push("/artefacts/" + id);
      }
    }
  },
  created() {
    
    if (!this.isAdmin && !this.isLoggedIn && !this.isMod)
      this.$router.push("/signin");
    else if (!this.isAdmin && this.isLoggedIn && !this.isMod)
      this.$router.push("/");
  },

  mounted() {
    this.loadRequests();
    document.title = "Tasks";
  }
};
</script>


<style scoped>
.collection-list-ie {
  display: inline;
}

.headline {
  position: absolute;
  bottom: 3%;
  left: 3%;
}

.tasksHeader {
  background-color: white;
  color: grey;
  border: 1px solid #efefef;
}

.beginningContainer {
  background-color: white;
  height: 100%;
  border-left: 1px solid #efefef;
  color: grey;
}
</style>
  


// WEBPACK FOOTER //
// src/components/Administration/Tasks.vue